/**
 * Represents the zeus.apollon_fk_conf.conf.objekte value object - the Foerderkategorie config
 * json structure
 *
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { createModel, Model, type MutationsObject } from '@kp/js-model';
import { ObjektRahmen } from '@/models/apollon_conf_fk/ObjektRahmen';

export class Objekte extends Model {
    visible: boolean = false
    infotext: string | null = null
    rahmen: { [key: string]: ObjektRahmen } = {}

    public mutations(): MutationsObject {
        return {
            rahmen: (val: { [key: string]: ObjektRahmen }) => {
                if (val) {
                    for (const key in val) {
                        val[key] = createModel(ObjektRahmen, val[key]);
                    }
                }
                return val;
            }
        };
    }
}
